import { render, staticRenderFns } from "./CXC.vue?vue&type=template&id=01d33172&"
import script from "./CXC.vue?vue&type=script&lang=js&"
export * from "./CXC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports